/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Disabled` - DISABLED
 * * `Pending` - PENDING
 * * `Enabled` - ENABLED
 */
export enum NotionIntegrationTenantExtensionStatus {
  DISABLED = 'Disabled',
  PENDING = 'Pending',
  ENABLED = 'Enabled',
}
